import {doMagic, clearCanvas, getCanvasData} from './canvasStuff';

class BodyworkController {
  constructor(vehicleService, $scope) {
    "ngInject";

    this.vehicleService = vehicleService;
    this.$scope = $scope;

    this.height = 900;
    this.width = 700;

    this.editImage();

    this.$scope.$on('vehicleAppraisal:parentFormConfigured', () => {
      this.editImage();
    });
  }

  editImage(img) {
    const ctrl = this;

    const height = this.height;
    const width = this.width;
    //var $imgToLoad = $('#appraisalImage');
    //var height = parseInt($imgToLoad.height());
    //var width = parseInt($imgToLoad.width());

    var $divCanvas = $(`<div idx="imageHolder" style="width:${width}px;height:${height}px;background: url('${this.vehicleAppraisal.imageUrl}'); background-repeat: no-repeat; background-size: 100% 100%;"><canvas width="${width}" height="${height}" style="opacity: .33;" id="sig-canvas"></canvas></div>`);
    $('.appraisal-container').empty().append($divCanvas);
    doMagic(this.saveEdit.bind(this));
  }

  reset() {
    clearCanvas();
    this.saveEdit();
  }

  saveEdit() {
    const ctrl = this;
    var imgData = getCanvasData();

    this.vehicleService.annotateImage(this.height, this.width, this.vehicleAppraisal.imageBase, imgData)
      .then(response => {
        ctrl.vehicleAppraisal.imageUrl = response.data;
      });
  }
}

export default BodyworkController;



// WEBPACK FOOTER //
// ./client/app/components/vehicle/vehicleAppraisal/bodywork/bodywork.controller.js